<template>

<core-panel>

	<template v-slot:head>

		<h1>Newcomers</h1>

		<p>The most recent new people played with.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in newcomers" subdate=":game on" :key="index" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'newcomers',
			newcomers: []
		}

	},

	methods: {

		response: function(json) {

			this.newcomers = json.newcomers

		}

	}

}

</script>